export default __webpack_public_path__ + "static/media/user-profile.627175fd.png";